<mat-dialog-content class="cart-details">

  <div class="details-section">
    <div class="total line">
      Total: {{ cart.total || 0 | amount | currency }}
    </div>
    <div class="line">
      <div class="subtitle">
        Reference:
      </div>
      <div class="value">
        {{ cart.id }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Created:
      </div>
      <div class="value">
        {{ cart.created | timestamp | date:'medium' }}
      </div>
    </div>
    @if(cart.status === 'COMPLETE') {
      <div class="line">
        <div class="subtitle">
          Paid:
        </div>
        <div class="value">
          {{ paid | timestamp | date:'medium' }}
        </div>
      </div>
    }
  </div>


  @for(order of cart.orders; track order.id) {
    <equine-ui-nx-order-table [order]="order"></equine-ui-nx-order-table>
  }

  <div class="details-section">
    <div class="line">
      <div class="subtitle">
        Service:
      </div>
      @if(cart.postPaymentData.paymentService === "BRAINTREE") {
        <div class="value">
          {{ cart.postPaymentData.paymentService }} ({{ cart.postPaymentData.paymentMethod }})
        </div>
      } @else {
        <div class="value">
          {{ cart.postPaymentData.paymentService }}
        </div>
      }
    </div>
    <div class="line">
      <div class="subtitle">
        Service reference:
      </div>
      <div class="value">
        {{ cart.postPaymentData.paymentServiceReference }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Payer reference:
      </div>
      <div class="value">
        {{ cart.postPaymentData.payerReference }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Payer email on service:
      </div>
      <div class="value">
        {{ cart.postPaymentData?.payer?.email || 'NA' }}
      </div>
    </div>
    <div class="line">
      <div class="subtitle">
        Payer email on service:
      </div>
      <div class="value">
        {{ cart.postPaymentData?.payer?.name || 'NA' }}
      </div>
    </div>

  </div>

</mat-dialog-content>